module.exports = __webpack_public_path__ + "static/media/graph.2cf11514.svg";